import { STATION_LOGO } from '@/lib/images'

interface WelcomeScreenProps {
  name: string
}

const EQ_HEIGHTS = [38, 62, 48, 86, 54, 94, 44, 78, 52, 68, 40]

function WelcomeScreen({ name }: WelcomeScreenProps) {
  const display = (name || 'Bem-vindo').trim()

  return (
    <div className="welcome-screen radio-bg fixed inset-0 z-[80] flex items-center justify-center overflow-hidden px-6">
      <div className="welcome-glow" aria-hidden />
      <div className="welcome-ring" aria-hidden />

      <div className="relative z-10 flex max-w-lg flex-col items-center text-center">
        <div className="welcome-logo-wrap">
          <img
            src={STATION_LOGO}
            alt="Bonita FM 87,9"
            className="h-[108px] w-auto max-w-[300px] object-contain sm:h-[138px] sm:max-w-[400px]"
          />
        </div>

        <div className="welcome-eq mt-10" aria-hidden>
          {EQ_HEIGHTS.map((height, index) => (
            <span
              key={index}
              className="welcome-eq-bar"
              style={{
                animationDelay: `${index * 0.12}s`,
                height: `${height}%`,
              }}
            />
          ))}
        </div>

        <p className="welcome-kicker mt-9 text-[11px] font-extrabold uppercase tracking-[0.42em] text-[#18c8f5]">
          Bonita FM 87,9
        </p>
        <h1 className="welcome-title mt-3 font-display text-3xl font-black leading-tight text-white sm:text-5xl">
          Bem-vindo, {display}!
        </h1>
        <p className="welcome-sub mt-3 text-sm font-medium text-white/75 sm:text-base">
          A sintonizar o seu painel ao vivo...
        </p>

        <div className="welcome-track mt-8" aria-hidden>
          <span className="welcome-track-fill" />
        </div>
      </div>
    </div>
  )
}

export default WelcomeScreen
